import { CenteredLoader } from '@trackman/baseball-shared-components';
import React from 'react';
import { LoaderWrapper } from './styles/LoaderStyles';

const Loader = () => {
  return (
    <LoaderWrapper>
      <CenteredLoader size='large' />
    </LoaderWrapper>
  );
};

export default Loader;
